<template>
  <v-dialog
    v-model="edit_dialog"
    scrollable  
    persistent :overlay="false"
    max-width="1200px"
    transition="dialog-transition"
  >
    <v-card id="scroll_cart">
      <v-toolbar dark color="accent">
        <v-toolbar-title>
          <v-icon size="18">shopping_cart</v-icon>
          <span :class="`${arabic?'arFont':'enFont'}`">معلومات الطلب</span>
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn small dark text :loading="loading" color="white" @click.native="hideEdit()" 
          :class="`${arabic?'arFont':'enFont'}`" style="font-size:12px;">
          الغاء التعديل
        </v-btn>
      </v-toolbar>
      <v-card>
        <v-card-title primary-title :style="`${language == 'ar' ? 'direction:rtl;text-align:right;' : null}`">
          <span :class="`${arabic?'arFont':'enFont'}`">{{ i18n.items_in_order }}</span>
        </v-card-title>
        <v-card-text>
          <v-row row wrap>
            <v-col v-for="p in cart" :key="p.sku" cols="12">
              <v-divider role="presentation"></v-divider>
              <v-row row wrap v-if="p" align-center>
                <v-col cols="4" md="1" class="text-center pa-1">
                  <v-badge color="red" overlap :left="language == 'ar'" :right="language == 'en'">
                    <template v-slot:badge>
                      <v-icon dark @click="removeFromCart(p)">
                        close
                      </v-icon>
                    </template>
                    <span>
                      <img :src="p.image.url" width="50%">
                    </span>
                  </v-badge>
                </v-col>
                <v-col cols="7" md="2" pa-1>
                  <div style="font-size:11px;font-weight:600;" :class="`${arabic?'arFont':'enFont'}`">
                    {{ i18n.item_name }}</div>
                  <span class="subtitle-2"
                    :class="`${ language == 'ar' ? 'arFont' : null }`">{{ p['name_' + language] }}</span>
                </v-col>
                <v-col cols="4" md="1" pa-1 v-if="!p.sizes">
                  <div style="font-size:11px;font-weight:600;" :class="`${arabic?'arFont':'enFont'}`">
                    {{ i18n.price }}</div>
                  <span class="subtitle-2"
                    :class="`${arabic?'arFont':'enFont'}`" 
                      >
                    {{ p.price }} {{currency_symbol}}
                  </span>
                </v-col>
                <v-col cols="7" md="1" pa-1 px-3 v-if="false && p.variants.length">
                  <v-select
                    :items="p.variants"
                    v-model="p.variant"
                    :label="i18n.size_color"
                    :class="`${arabic?'arFont':'enFont'}`"
                    item-text="name_en"
                    return-object
                  ></v-select>
                </v-col>
                <v-col cols="7" md="2">
                  <v-text-field 
                    :label="i18n.quantity" 
                    v-model="p.order_quantity"
                    :class="`${arabic?'arFont':'enFont'}`" 
                    hide-details
                    dense
                    readonly
                    outlined
                    @keypress="isNumber($event)"
                  >
                    <template v-slot:prepend>
                      <v-tooltip
                        top
                      >
                        <template v-slot:activator="{ on }">
                          <v-btn small outlined :loading="loading" color="error" icon v-on="on" @click="decreaseQuantity(p)">
                            <v-icon>
                              keyboard_arrow_down
                            </v-icon>
                          </v-btn>
                        </template>
                        <span :class="`${arabic?'arFont':'enFont'}`">تقليل الكمية</span>
                      </v-tooltip>
                    </template>
                    <template v-slot:append-outer>
                      <v-tooltip
                        top
                      >
                        <template v-slot:activator="{ on }">
                          <v-btn small outlined icon color="success" :disabled="p.order_quantity >= 10" v-on="on" @click="increaseQuantity(p)">
                            <v-icon>keyboard_arrow_up</v-icon>
                          </v-btn>
                        </template>
                        <span :class="`${arabic?'arFont':'enFont'}`">زيادة الكمية</span>
                      </v-tooltip>
                    </template>
                  </v-text-field>
                </v-col>
                <v-col cols="12" md="2" class="">
                  <v-text-field
                    label="صافي الربح للقطعة الواحدة"
                    :class="`${arabic?'arFont':'enFont'}`"
                    @keypress="isNumber($event)"
                    @input="getProductTotals(p)"
                    outlined
                    dense
                    v-model="p.user_profit"
                    hide-details
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="1" pa-1 class="secondary white--text">
                  <div style="font-size:11px;font-weight:400;" :class="`${arabic?'arFont':'enFont'}`">
                    المجموع</div>
                  <span class="subtitle-2"
                    :class="`${arabic?'arFont':'enFont'}`">
                    {{ p.total  }} {{currency_symbol}} ({{p.base_total}}$)
                  </span>
                </v-col>
                <v-col cols="12" md="1" pa-1 class="primary white--text">
                  <div style="font-size:11px;font-weight:400;" :class="`${arabic?'arFont':'enFont'}`">
                    صافي الربح</div>
                  <span class="subtitle-2"
                    :class="`${arabic?'arFont':'enFont'}`">
                    {{ p.total_profit  }} {{currency_symbol}}
                  </span>
                </v-col>
                <v-col cols="12" md="2" pa-1 class="primary white--text">
                  <div style="font-size:11px;font-weight:400;" :class="`${arabic?'arFont':'enFont'}`">
                    صافي الربح بالدولار</div>
                  <span class="subtitle-2" :class="`${arabic?'arFont':'enFont'}`">
                    ${{ p.base_total_profit  }}
                  </span>
                </v-col>
              </v-row>
              <v-divider role="presentation"></v-divider>
            </v-col>
          </v-row>
          <v-row row wrap pa-2>
            <v-col cols="12" md="8">
            </v-col>
            <v-col cols="12" md="4">
              <v-card outlined class="pa-2 pt-0">
                <v-row row wrap>
                  <v-col cols="12" :class="`${arabic?'arFont':'enFont'} primary white--text text-center`">
                    ملخص الطلب
                  </v-col>
                  <v-col cols="8" :class="`${arabic?'arFont':'enFont'}`" style="font-weight:bold;">
                    عدد المنتجات المحددة
                  </v-col>
                  <v-col cols="4" :class="`${arabic?'arFont':'enFont'}`" style="font-weight:bold;">
                    {{cart.length}}
                  </v-col>
                  <v-col cols="8" :class="`${arabic?'arFont':'enFont'}`" style="font-weight:bold;">
                    تكاليف الشحن
                  </v-col>
                  <v-col cols="4" :class="`${arabic?'arFont':'enFont'}`">
                    <span style="font-weight:bold;">{{ cart_delivery_fees }}</span> {{currency_symbol}}
                  </v-col>
                  <v-col v-if="cart_tax > 0" cols="8" :class="`${arabic?'arFont':'enFont'}`" style="font-weight:bold;">
                    <div>ضريبة القيمة المضافة</div>
                    <div>({{tax * 100}}%)</div>
                  </v-col>
                  <v-col v-if="cart_tax > 0" cols="4" :class="`${arabic?'arFont':'enFont'}`">
                    <span style="font-weight:bold;">{{ cart_tax }}</span> {{currency_symbol}}
                  </v-col>
                  <v-col cols="8" :class="`${arabic?'arFont':'enFont'} primary--text`" style="font-weight:bold;">
                    مجموع صافي الربح
                  </v-col>
                  <v-col cols="4" :class="`${arabic?'arFont':'enFont'} primary white--text`">
                    <div><span style="font-weight:bold;">{{ total_profit }}</span> {{currency_symbol}} ({{ base_total_profit }} دولار)</div>
                  </v-col>
                  <v-col cols="12" :class="`${arabic?'arFont':'enFont'}`" style="font-weight:bold;">
                    <v-divider></v-divider>
                  </v-col>
                  <v-col cols="8" :class="`${arabic?'arFont':'enFont'}`" style="font-weight:bold;">
                    المستحق الدفع
                  </v-col>
                  <v-col cols="4" :class="`${arabic?'arFont':'enFont'}`">
                    <div><span style="font-weight:bold;">{{ cart_total }}</span> {{currency_symbol}} </div> 
                    <div>({{ base_total }} دولار)</div>
                  </v-col>
                </v-row>
              </v-card>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-title primary-title DETAILS>
          <span :class="`${arabic?'arFont':'enFont'}`">معلومات المشتري</span>
        </v-card-title>
        <v-card-text id="finish" DETAILS>
          <v-row row wrap pa-2>
            <v-col  class="py-0" cols="12" md="6" px-1>
              <v-autocomplete
                label="الدولة" 
                outlined
                :items="countries"
                dense
                disabled
                item-text="name"
                return-object
                :loading="loading"
                :class="` specialInput ${arabic?'arFont':'enFont'}`"
                @change="loadCities(newLead.country)"
                v-model="newLead.country">
              </v-autocomplete>
            </v-col>
            <v-col  class="py-0" cols="12" md="6" px-1>
              <v-text-field 
                :label="i18n.name" 
                outlined
                dense
                :disabled="loading"
                :loading="loading"
                :class="` specialInput ${arabic?'arFont':'enFont'}`"
                  
                v-model="newLead.name">
              </v-text-field>
            </v-col>
            <v-col  class="py-0" cols="12" md="6" px-1>
              <v-text-field 
                :label="i18n.phone_number" 
                outlined
                dense
                :disabled="loading"
                :loading="loading"
                :class="` specialInput ${arabic?'arFont':'enFont'}`"
                @keypress="isNumber($event)"
                v-model="newLead.phone_number_1"
                @change="checkPhone()">
              </v-text-field>
            </v-col>
            <v-col  class="py-0" cols="12" md="6" px-1>
              <v-text-field 
                label="رقم هاتف ثاني" 
                outlined
                dense
                :disabled="loading"
                :loading="loading"
                :class="` specialInput ${arabic?'arFont':'enFont'}`"
                @keypress="isNumber($event)"
                v-model="newLead.phone_number_2"
                @change="checkPhone()">
              </v-text-field>
            </v-col>
            
            <v-col  class="py-0" cols="12" md="6" px-1>
              <v-autocomplete
                label="المدينة" 
                outlined
                dense
                :items="cities"
                return-object
                :disabled="loading"
                @change="setDelivery()"
                :loading="loading"
                :filter="filterObject"
                :class="`specialInput ${arabic?'arFont':'enFont'}`"
                v-model="newLead.city">
                <template v-slot:selection="{ attr, on, item, selected }">
                  <span
                    v-bind="attr"
                    :input-value="selected"
                    v-on="on"
                    :class="`${arabic?'arFont':'enFont'}`"
                  >
                    <v-chip x-small>{{item.name}}</v-chip>
                  </span>
                </template>
                <template v-slot:item="{ item }">
                  <div :class="`${arabic?'arFont':'enFont'}`">
                    {{item.name}}
                  </div>
                  <div :class="`${arabic?'arFont':'enFont'}`" style="font-size:11px;">
                    (رسوم الشحن {{(currency_factor * item.fee).toFixed(2)}} {{currency_symbol}})
                  </div>
                </template>
              </v-autocomplete>
            </v-col>
            <v-col  class="py-0" cols="12" md="6" px-1>
              <v-text-field 
                label="العنوان" 
                outlined
                dense
                hint="(المنطقة, اسم الشارع, رقم العقار , رقم الشقة)"
                :disabled="loading"
                :loading="loading"
                :class="` specialInput ${arabic?'arFont':'enFont'}`"
                v-model="newLead.address">
              </v-text-field>
            </v-col>
            <v-col  class="py-0" cols="12" md="6" px-1>
              <v-text-field 
                label="اسمك التجاري او اسم الصفحة او الشركة التي تستخدمها للبيع" 
                outlined
                dense
                :disabled="loading"
                :loading="loading"
                :class="` specialInput ${arabic?'arFont':'enFont'}`"
                v-model="newLead.business_name">
              </v-text-field>
            </v-col>
            <v-col  class="py-0" cols="12" md="6" px-1>
              <v-textarea 
                label="ملاحظات" 
                outlined
                dense
                :disabled="loading"
                :loading="loading"
                :class="` specialInput ${arabic?'arFont':'enFont'}`"
                v-model="newLead.note">
              </v-textarea>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text large :loading="loading" color="primary" @click.native="hideEdit()"
            :class="`${arabic?'arFont':'enFont'}`">الغاء التعديل</v-btn>
          <v-btn large :loading="loading" color="accent" @click="SubmitEdit()"
            :class="`${arabic?'arFont':'enFont'}`">ارسال تعديل الطلب</v-btn>
        </v-card-actions>
      </v-card>
    </v-card>
  </v-dialog>
</template>

<script>
import {firebase, db, auth, store} from '@/fb';
import { getRandomInt, randomString, getCDate, check } from '@/customFunction';
import axios from 'axios';
let apiBase = 'https://us-central1-ashyaatcrm.cloudfunctions.net/main'
const headers = {'Accept': 'application/json'};

export default {
  data(){
    return {
      phoneNumber:null,
      name:null,
      orderloading:false,
      newLead:{},
      cities:[],
    }
  },
  methods: {
    filterObject(item, queryText, itemText) {
      let v = Object.values(item).filter(x=>typeof x == 'string')
      let a = false
      v.forEach(x=>{
        if(x.toLowerCase().includes(queryText.toLowerCase())) a = true
      })
      if(itemText && typeof itemText == 'string' && itemText.toLowerCase().includes(queryText.toLowerCase())) a = true
      return a
    },
    setDelivery(){
      if(this.newLead && this.newLead.city) {
        this.$store.state.delivery_fees = parseFloat((parseFloat(this.newLead.city.fee) * this.currency_factor).toFixed(2))
        this.$store.state.base_delivery_fees = parseFloat((parseFloat(this.newLead.city.fee)).toFixed(2))
        this.$store.state.cart_delivery_fees = parseFloat((parseFloat(this.newLead.city.fee) * this.currency_factor).toFixed(2))
        this.$store.state.base_cart_delivery_fees = parseFloat((parseFloat(this.newLead.city.fee)).toFixed(2))
        this.$store.commit('setCartTotal')
      }
    },
    loadCities(c){
      this.newLead.city = null
      this.cities=c.cities
      // console.log(c)
    },
    setCookie(name, value, days) {
      var expires = "";
      var maxAge = "";
      if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        expires = "; expires=" + date.toUTCString();
        maxAge = "; max-age=" + date.toUTCString();
      }
      document.cookie = name + "=" + (value || "") + expires + "; path=/";
    },
    getCookie(name) {
      var nameEQ = name + "=";
      var ca = document.cookie.split(';');
      for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
      }
      return null;
    },
    isNumber(evt) {
      evt = (evt) ? evt : window.event;
      var charCode = (evt.which) ? evt.which : evt.keyCode;
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
        evt.preventDefault();;
      } else {
        return true;
      }
    },
    hideEdit() {
      this.$store.state.edit_dialog = false
    },
    getProductTotals(p) {
      this.$store.dispatch('getProductTotals', p)
    },
    removeFromCart(p) {
      this.$store.dispatch('removeFromCart', p)
    },
    increaseQuantity(p){
      this.$store.dispatch('increaseQuantity', p)
    },
    decreaseQuantity(p){
      this.$store.dispatch('decreaseQuantity', p)
    },
    scrollDown(){
      var container = document.querySelector(".v-dialog--scrollable");
      container.scrollTop = container.scrollHeight;
    },
    syncCustomer(){
      // console.log('this.customer', this.customer)
      if (this.customer && this.customer.name) {
        this.loadCities(this.$store.state.country)
        this.newLead = this.customer
        this.newLead.city = this.cities.filter(x=>x.id == this.customer.city_id)[0]
        this.newLead.country = this.$store.state.country
      }
      
    },
    async checkPhone(phone, country) {
      return new Promise((res, rej)=>{
        if(!phone || !country) {
          res(false)
        }
        let phoneNumber = phone
        if(phoneNumber) {
          phoneNumber = phoneNumber.replace(/[٠١٢٣٤٥٦٧٨٩]/g, function (d) {
            return d.charCodeAt(0) - 1632;                
          }).replace(/[۰۱۲۳۴۵۶۷۸۹]/g, function (d) { return d.charCodeAt(0) - 1776; })
        }
        
        return axios.get(`https://us-central1-ashyaatcrm.cloudfunctions.net/ash_phone/vPhone?phone=${encodeURI(phoneNumber)}&cc=${country.alpha2Code}`)
        .then(resp=>{
          if(resp.data.corrected && resp.data.g && resp.data.g.isValidNumber) {
            res(resp.data.corrected ? resp.data.corrected : phoneNumber)
          } else {
            this.$emit('snackbarNotification', `Please correct your phone number`, 'error')
            res(false)
          }
        })
      })
    },
    async checkNumberBlocked(cip){
      return new Promise(async (res, rej)=>{
        let a = await db.ref('blocknumberlist').once('value').then(x=>x.val())
        if(a) {
          let b = Object.values(a)
          let c = b.map(x=>x.number)
          // console.log(cip)
          if(c.includes(`${cip}`)){
            res(true)
          } else {
            res(false)
          }
        } else {
          res(false)
        }
      })
    },
    validate(){
      if(!this.cart.length) {
        this.$emit('snackbarNotification', `العربة فارغة`, 'error')
        return false
      }
      if(!this.newLead.name) {
        this.$emit('snackbarNotification', `الاسم مطلوب`, 'error')
        return false
      }
      if(!this.newLead.phone_number_1) {
        this.$emit('snackbarNotification', `رقم الهاتف مطلوب`, 'error')
        return false
      }
      if(!this.newLead.country) {
        this.$emit('snackbarNotification', `البلد مطلوبة`, 'error')
        return false
      }
      if(!this.newLead.city) {
        this.$emit('snackbarNotification', `المدينة مطلوبة`, 'error')
        return false
      }
      if(!this.newLead.address) {
        this.$emit('snackbarNotification', `العنوان مطلوب`, 'error')
        return false
      }
      if(!this.newLead.business_name) {
        this.$emit('snackbarNotification', `اسمك التجاري مطلوب مطلوب`, 'error')
        return false
      }
      return true
    },
    async SubmitEdit(){
      let nDate = await axios.get(`${apiBase}/getDate`).then(x=>x.data.date)
      let m = await this.checkPhone(this.newLead.phone_number_1, this.newLead.country)
      let m2 = this.newLead.phone_number_2
      let fraud_check = false
      
      if(this.validate() && m) {
        let order = []
        let cart = this.cart
        let item_name_collector = ``
        for (let i = 0; i < cart.length; i++) {
          const item = cart[i];
          let p = {
            product:item.item_name,
            price:item.price_name,
            sku:item.sku,
            discount:0,
            id:item.id,
            baseprice:item.base_price,
            quantity:item.order_quantity,
            variant:item.variant,
            total:item.total,
            ...item
          }
          // if(item.variant) {
          //   console.log('item.variant', item.variant)
          //   p.product = item.variant.name
          //   p.sku = item.variant.sku
          // }
          item_name_collector += `${item.order_quantity} X | ${item.sku} - ${item.name_ar}\n`
          order.push(p)
        }
        let data = {
          ...this.newLead,
          ///
          without_delivery:this.newLead.without_delivery,
          business_name:this.newLead.business_name,
          name:this.newLead.name,
          language:this.language,
          country_object:this.newLead.country,
          city:this.newLead.city.name,
          city_object:this.newLead.city,
          cc:this.newLead.country.alpha2Code,
          country:this.newLead.country.name,
          phone_number_1:m,
          phone_number_2:m2,
          campaign_code:order.map(x=>x.sku).join('|') + ` NINJA`,
          total:this.cart_total,
          delivery_fees:this.cart_delivery_fees,
          tax:this.cart_tax,
          address:this.newLead.address,
          note:this.newLead.note,
          date:nDate,
          timestamp:new Date().getTime(),
          import_date:nDate,
          order_status:'NEW',
          item_name: order.map(x=>x.sku).join(' | ') + '\n\r' + item_name_collector + '\n\r' + 'TOTAL:' + parseFloat(this.cart_total),
          ip:this.location.ip,
          order,
          token:`${randomString(3, 'Aa')}-${randomString(6, 'Aa')}`,
          order_source:'NINJA',
          company_code:'NINJA',
          total_profit:this.$store.state.total_profit,
          base_total:this.$store.state.base_total,
          base_profit:this.$store.state.base_total_profit,
          currency_symbol:this.$store.state.currency_symbol,
          currency_factor:this.$store.state.currency_factor,
          base_delivery_fees:this.$store.state.base_delivery_fees,
          cart_delivery_fees:this.$store.state.cart_delivery_fees,
          base_cart_delivery_fees:this.$store.state.base_cart_delivery_fees,
          free_delivery_limit:this.$store.state.free_delivery_limit,
          base_free_delivery_limit:this.$store.state.base_free_delivery_limit,
          tax:this.$store.state.tax,
          cart_tax:this.$store.state.cart_tax,
        };
        data.key = this.newLead.key
        // let mss = await store.collection('leads').doc(key.key).set(data)
        try {
          let larastore = await axios.put('https://yervip.com/api/v1/leads/' + this.newLead.id , data, {headers}).then(x=>x.data)
          // console.log('larastore', larastore)
        } catch (error) {
          // console.log('larastore error', error)
        }
        try {
          data.key = this.newLead.key
          // let automation = await axios.post(`${apiBase}/newLeads`, data, {headers}).then(x=>x.data)
          // console.log('automation', automation)
        } catch (error) {
          // console.log('automation error', error)
        }
        this.$store.state.cart = []
        this.hideEdit()
        this.$emit('loadResource')
        this.$emit('snackbarNotification', `تم تحديث الطلب`, 'success')
        
      } else {
      }
    },
  },
  watch:{
    cart(){
      if(this.cart.length < 1) {
        this.hideEdit()
      }
    },
    edit_dialog(){
      this.syncCustomer()
    }
  },
  computed:{
    edit_dialog(){
      return this.$store.state.edit_dialog
    },
    currency_factor(){
      return this.$store.state.currency_factor
    },
    currency_symbol(){
      return this.$store.state.currency_symbol
    },
    tax(){
      return this.$store.state.tax
    },
    base_total(){
      return this.$store.state.base_total
    },
    base_total_profit(){
      return this.$store.state.base_total_profit
    },
    total_profit(){
      return this.$store.state.total_profit
    },
    countries(){
      return this.$store.state.countries
    },
    arabic(){
      if(this.$store.state.language == 'ar') return true
    },
    products() {
      return this.$store.state.products
    },
    i18n(){
      return this.$store.state.i18n[this.$store.state.language]
    },
    language(){
      return this.$store.state.language
    },
    loading(){
      return this.$store.state.loading
    },
    currency_symbol(){
      return this.$store.state.currency_symbol
    },
    currency_factor(){
      return this.$store.state.currency_factor
    },
    cart(){
      return this.$store.state.cart
    },
    show_cart(){
      if(!this.newLead.country) {
        this.newLead.country = this.$store.state.country
      }
      if(!this.cities || !this.cities.length) {
        // console.log('mounted country of state', this.$store.state.country)
        this.loadCities(this.$store.state.country)
      }
      return this.$store.state.show_cart
    },
    country_code(){
      return this.$store.state.country_code
    },
    country(){
      return this.$store.state.country
    },
    cart_total(){
      return this.$store.state.cart_total
    },
    cart_delivery_fees(){
      return this.$store.state.cart_delivery_fees
    },
    customer(){
      return this.$store.state.edit_lead
    },
    location(){
      return this.$store.state.location
    },
    comapny_code(){
      return this.$store.state.comapny_code
    },
    is_landing_page(){
      return this.$store.state.is_landing_page
    },
    pixel_submit(){
      return this.$store.state.pixel_submit
    },
    tax(){
      return this.$store.state.tax
    },
    cart_tax(){
      return this.$store.state.cart_tax
    },
  },
  mounted(){
  },
  created(){
    if(!this.newLead.country) {
      this.newLead.country = this.$store.state.country
    }
    if(!this.newLead.business_name) {
      this.newLead.business_name = this.$store.state.user.account.name
    }
    if(!this.cities || !this.cities.length) {
      // console.log('mounted country of state', this.$store.state.country)
      this.loadCities(this.$store.state.country)
    }
  }
}
</script>
